<layout-wrapper class="page-title hide-on-mobile static-content">
  <div class="chat-header-wrapper">
    <div class="chat-header-wrapper">
      <h2>Chats</h2>
      <ng-container *ngTemplateOutlet="viewOnlineButton"></ng-container>
    </div>
    <app-button
      title="New Chat"
      [size]="'small'"
      [style]="'filled'"
      icon="add-white"
      (onCLick)="openUsersList(true)"
    ></app-button>
  </div>
</layout-wrapper>
<div class="row g-0 content-padding"></div>


<ng-container *ngIf="{
    allUsersMap: allUsersMap$ | async,
    conversations: conversations$ | async,
    conversationsLoading: conversationsLoading$ | async
  } as ctx">

  <ng-container *ngIf="!ctx.conversationsLoading else loadingTpl">
    <ng-container *ngIf="ctx.conversations?.length else emptyState">

      <layout-wrapper 
        [bottomBorder]="true" 
        *ngFor="let conversation of ctx.conversations; let last = last;"
      >
        <app-chat-list-item
          [conversation]="conversation"
          [mainParticipantUser]="getParticipantUser(ctx.allUsersMap, conversation)">
        </app-chat-list-item>
      </layout-wrapper>
    </ng-container>
  </ng-container>

  <ng-template #emptyState>
    <layout-wrapper>
      <div class="empty-state">
        <h3 class="text-h3">No active chats yet</h3>
        <p class="text-body">Start new chat or visit a user's profile and click "Send Message" to start a conversation!</p>
      </div>
    </layout-wrapper>
  </ng-template>

  <ng-template #loadingTpl>
    <layout-wrapper>
      <app-spinner></app-spinner>
    </layout-wrapper>
  </ng-template>
</ng-container>

<ng-template #newChatButton>
  <app-button
    [size]="'small'"
    icon="add-square-blue"
    (onCLick)="openUsersList(true)"
  ></app-button>
</ng-template>

<ng-template #viewOnlineButton>
  <app-button 
    [title]="onlineUsersButtonTitle$ | async"
    [style]="'link'"
    [size]="'small'"
    (onCLick)="openUsersList()"
  ></app-button>
</ng-template>

<app-adaptive-modal [title]="usersListModalName | async" [showModal]="openUsersListModal" [fullscreen]="true">
  <app-new-chat-user-search 
    [onlineUsers]="onlineUsers$"
    (onClick)="openUsersListModal.next(false)"
  ></app-new-chat-user-search>
</app-adaptive-modal>